import { useEffect, useState } from 'react';

import { useNavigate } from 'react-router-dom';

// material-ui
import { Box, Button, Card, CardContent, CardHeader, Divider, Grid, Typography, Tabs, Tab } from '@mui/material';

import { gridSpacing } from 'store/constant';
import Breadcrumb from 'components/ui/Breadcrumb';
import DashboardCard from '../components/dashboard/DashboardCard';
import { IconBuilding, IconBook, IconQuestionMark, IconUsers } from '@tabler/icons';
import { getDashboardDataRequest } from 'services/dashboard';
import { extractValue } from '../utils';
import { DataGrid } from '@mui/x-data-grid';
import {
    getStudentRequest,
    getTestimonialReceivedRequest,
    getTestimonialSentRequest,
    addRequestTestimonialRequest
} from 'services/requestedTestimonial';
import RequestedTestimonialForm from 'components/requestedTestimonial/RequestedTestimonialForm';
import appUrls from 'appUrls';
import TestimonialModal from 'components/testimonial/TestimonialModal';

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div role="tabpanel" hidden={value !== index} id={`simple-tabpanel-${index}`} aria-labelledby={`simple-tab-${index}`} {...other}>
            {value === index && (
                <Box>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`
    };
}

const Dashboard = () => {
    const [isLoading, setLoading] = useState(true);
    const [testimonialSentData, setTestimonialSentData] = useState('');
    const [testimonialReceivedData, setTestimonialReceivedData] = useState('');
    const navigate = useNavigate();
    const [value, setValue] = useState(0);
    const [open, setOpen] = useState(false);
    const [student, setStudent] = useState({});
    const [studentId, setStudentId] = useState('');

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const handleWrite = (param) => {
        console.log(param);
    };

    const handleSubmitRequestedTestimonial = async (values, { resetForm, setSubmitting }) => {
        setSubmitting(true);
        const payload = {
            studentReqTo: extractValue(values.student, '_id'),
            notes: values.notes
        };

        console.log(payload, 'payload');
        const response = await addRequestTestimonialRequest(payload);
        // console.log('-> response', response);
        if (response.error === false) {
            resetForm();
            navigate(appUrls.TESTIMONIAL);
        }
        setSubmitting(false);
    };

    const sentColumns = [
        {
            field: 'rowId',
            headerName: 'Sr.No.',
            flex: 10
        },
        {
            field: 'studentReqTo',
            headerName: 'Student Name',
            flex: 10,
            renderCell: (params) => <div>{params.value.name}</div>
        },
        {
            field: 'notes',
            headerName: 'Notes',
            flex: 10
        }
    ];

    const receivedColumns = [
        {
            field: 'rowId',
            headerName: 'Sr.No.',
            flex: 10
        },
        {
            field: 'studentReqBy',
            headerName: 'Student Name',
            flex: 10,
            renderCell: (params) => <div>{params.value.name}</div>
        },
        {
            field: 'notes',
            headerName: 'Notes',
            flex: 10
        },
        {
            field: '_id',
            flex: 5,
            headerName: 'Actions',
            renderCell: (params) => (
                <Button
                    variant="outlined"
                    color="success"
                    size="small"
                    style={{ marginLeft: 16 }}
                    onClick={() => {
                        setStudentId(params.row._id);
                        setStudent(params.row.studentReqBy);
                        setOpen(true);
                        console.log(params.row.studentReqBy);
                    }}
                >
                    Write
                </Button>
            )
        }
    ];

    useEffect(() => {
        async function fetchData() {
            setLoading(true);
            const data = await getStudentRequest();
            const testimonialSent = await getTestimonialSentRequest();
            const testimonialReceived = await getTestimonialReceivedRequest();

            setLoading(false);
            if (data.error === false) {
                setTestimonialSentData(
                    testimonialSent.sentTestimonials.map((x, index) => ({
                        ...x,
                        rowId: index + 1
                    }))
                );
                setTestimonialReceivedData(
                    testimonialReceived.receiveTestimonials.map((x, index) => ({
                        ...x,
                        rowId: index + 1
                    }))
                );
            }
        }
        fetchData();
    }, []);

    return (
        <>
            <Breadcrumb title="Request Testimonial" />
            <Grid container spacing={gridSpacing}>
                <Grid item xs={12}>
                    <Grid container spacing={gridSpacing}>
                        <Grid item xs={12}>
                            <Card>
                                {/* <CardHeader
                                    title="Poll Options"
                                    sx={{
                                        p: 2
                                    }}
                                /> */}
                                {/* <Divider /> */}
                                <CardContent>
                                    <Box
                                        p={1}
                                        pt={0}
                                        style={{
                                            // height: 500,
                                            width: '100%'
                                        }}
                                    >
                                        <RequestedTestimonialForm handleSubmit={handleSubmitRequestedTestimonial} />
                                    </Box>
                                </CardContent>
                            </Card>
                        </Grid>
                    </Grid>
                </Grid>

                <Grid item xs={12}>
                    <Grid container spacing={gridSpacing}>
                        <Grid item xs={12}>
                            <Card>
                                <Box sx={{ display: 'flex', justifyContent: 'space-between', borderBottom: 1, borderColor: 'divider' }}>
                                    <Typography padding="12px" variant="h3">
                                        Requested Testimonial
                                    </Typography>
                                    <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
                                        <Tab label="Received" {...a11yProps(0)} />
                                        <Tab label="Sent" {...a11yProps(1)} />
                                    </Tabs>
                                </Box>
                                <TabPanel value={value} index={0}>
                                    <CardContent>
                                        <Box
                                            p={1}
                                            pt={0}
                                            style={{
                                                // height: 500,
                                                width: '100%'
                                            }}
                                        >
                                            {!testimonialReceivedData && 'Loading...'}
                                            {testimonialReceivedData && (
                                                <DataGrid
                                                    rows={testimonialReceivedData}
                                                    columns={receivedColumns}
                                                    getRowId={(row) => row._id}
                                                    pagination
                                                    paginationMode="client"
                                                    // rowsPerPageOptions={[5, 10, 25]}
                                                    isRowSelectable={false}
                                                    row
                                                    autoHeight
                                                    disableColumnMenu
                                                />
                                            )}
                                        </Box>
                                    </CardContent>
                                </TabPanel>
                                <TabPanel value={value} index={1}>
                                    <CardContent>
                                        <Box
                                            p={1}
                                            pt={0}
                                            style={{
                                                // height: 500,
                                                width: '100%'
                                            }}
                                        >
                                            {!testimonialSentData && 'Loading...'}
                                            {testimonialSentData && (
                                                <DataGrid
                                                    rows={testimonialSentData}
                                                    columns={sentColumns}
                                                    getRowId={(row) => row._id}
                                                    pagination
                                                    paginationMode="client"
                                                    // rowsPerPageOptions={[5, 10, 25]}
                                                    isRowSelectable={false}
                                                    row
                                                    autoHeight
                                                    disableColumnMenu
                                                />
                                            )}
                                        </Box>
                                    </CardContent>
                                </TabPanel>
                            </Card>
                        </Grid>
                    </Grid>
                </Grid>
                {/* <TestimonialModal open={open} setOpen={setOpen} /> */}
            </Grid>
            <TestimonialModal initialValues={{ student, comment: '' }} open={open} setOpen={setOpen} studentId={studentId} />
        </>
    );
};

export default Dashboard;
